import { createAssetsQuery } from '../mutations';
import makeRequest from '../../../../common/utils/makeRequest';










export default async function createAssets(apiClient, input) {
  const requestParams = {
    mutation: createAssetsQuery,
    variables: { input },
    context: { module: 'upload' }
  };
  const { data, error } = await makeRequest({ request: apiClient.mutate, requestParams });

  if (!data || !data.createAssets || error) {return null;}

  return data.createAssets;
}